import { render } from "./AutoCompleteProducts.vue?vue&type=template&id=59831384&ts=true"
import script from "./AutoCompleteProducts.vue?vue&type=script&lang=ts"
export * from "./AutoCompleteProducts.vue?vue&type=script&lang=ts"

import "./AutoCompleteProducts.vue?vue&type=style&index=0&id=59831384&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__